/***
 * @file: 
 * @author: xiaoyu.chen
 * @Date: 2025-08-13 11:20:52
 */

import { useStorage } from "@vueuse/core";
import type {WatchHandle} from "vue";

const themeColor = ref('')
let themeWatcher: WatchHandle|null = null
export const useTheme = () => {
    const themeState = useState<string>('themeColor', () => '')
    const themeCookie =  useCookie('themeColor', {
        maxAge: 30 * 24 * 60 * 60
    })

    themeColor.value = themeState.value || themeCookie.value || 'dark'

    if (!themeWatcher) {
        themeWatcher = watch(() => themeColor.value, (n) => {
            themeState.value = n || ''
            themeCookie.value = n || ''
            useHead({
                htmlAttrs: { 'data-theme': n }
            })
        }, { deep: true})
    }
    return { themeColor }
}


/**
 * 获取最近N天的日期数组
 * @param days - 需要获取的天数
 * @returns 返回包含最近N天日期字符串的数组，格式为YYYY-MM-DD
 */
export const getRecentDays = (days: number) => {
  const date = new Date() // 获取当前日期
  const result = [] // 用于存储日期结果的数组
  for (let i = 0; i < days; i++) {
    // 计算前一天的日期：通过减去i天的毫秒数
    const newDate = new Date(date.getTime() - i * 24 * 60 * 60 * 1000)
    // 将日期转换为ISO格式并分割，取日期部分（YYYY-MM-DD）
    result.push(newDate.toISOString().split('T')[0])
  }
  return result
}